<template>
  <div style="padding:0  24px">
    <div >
      <Button type="primary" @click="addTypeItem" :disabled="!(projectFid && dataList.length>0 && !done)" v-p="{api:'housetype/add'}">添加房型信息</Button>
    </div>
    <type-item v-for="(item,index) in dataList"
               :formData="item"
               :index="index"
               @deleteitem="deleteItem"
               :ref="'typeitem'+index"
               :key="'keyA'+index"
               :disabled="!(projectFid && dataList.length>0 && !done)"
               :houseTypeEnum="houseTypeEnum"
    ></type-item>
    <div>
      <save-and-cancel v-if="projectFid && dataList.length>0 && !done" @save="save" @cancel="cancel" v-p="{api:'housetype/add'}">
      </save-and-cancel>
    </div>
    <!--<div v-else class="cannot"><Button :size="big" >请先进行基本信息的添加</Button></div>-->
  </div>
</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import TypeItem from '../../components/TypeItem'
  import {housetypeAdd,forCondition} from "../../../../../api/project";
  import { getSelectHouseTypes } from 'api/project'

  export default {
    name:'TypeAdd',
    components: {
      SaveAndCancel,
      TypeItem
    },
    props:{
      projectFid:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        // projectFid:'8a9091b0653274dc01653274dc6a0000',
        done:false,
        houseTypeEnum:[],
        dataList: [
          {
            "houseTypeArea": '',
            "houseTypeBathroom": '',
            "houseTypeDescription": "",
            "houseTypeHall": "",
            "houseTypeName": "",
            "houseTypeImage": "",
            "houseTypeRooms": "",
            "remark": ""
          }
        ]
      }
    },
    methods: {
      validForm(){
        var flag=true
        for(var i  in this.$refs){
          this.$refs[i][0]&&this.$refs[i][0].$refs['typeItem'].validate(bool=>{
            if(bool===false){
              flag=false
            }
          })
        }
        return flag
      },
      deleteItem(index){
        if(!(this.projectFid && this.dataList.length>0 && !this.done)){
          return
        }
        if(!this.projectFid){
          this.$Message.info('请先进行基本信息的添加')
          return
        }

        this.$Modal.confirm({
          content:'<p>确认删除本条楼栋记录？</p>',
          onOk:()=>{
            this.dataList.splice(index,1)
          }
        })
      },
      save() {
        if(!this.validForm()){
          this.$Message.info('请检查填写内容！')
          return
        }

        this.dataList.forEach(ele=>{
          ele['projectFid']=this.projectFid
        })
        var params={
          projectFid:this.projectFid,
          houseTypeDtos:this.dataList
        }
        housetypeAdd(params).then(res=>{
          if(res.code==0){
            this.$Message.success('房型信息添加成功')
            this.done=true
          }
        })
      },
      cancel() {

      },
      addTypeItem() {
        if(!this.projectFid){
          this.$Message.info('请先进行基本信息的添加')
          return
        }
        this.dataList.push(
          {
            // "fid": "",
            "houseTypeArea": '',
            "houseTypeBathroom": '',
            "houseTypeDescription": "",
            "houseTypeHall": "",
            "houseTypeName": "",
            "houseTypeImage": "",
            "houseTypeRooms": "",
            "projectFid": "",
            "remark": ""
          }
        )
        // this.typeList.unshift(3)
      }
    },
    created(){
      // this.forCondition()
      getSelectHouseTypes().then( res => {
        this.houseTypeEnum = res.data
      })
    }
  }
</script>
<style scoped>
  .cannot{
    text-align: center;
    margin-top: 200px;

  }


</style>
